import { defineMessages } from 'react-intl';

export default defineMessages({
	copy: {
		id: 'backNavButton.copy',
		defaultMessage: 'Go Back',
		description: 'Link to go to the previous page',
	},
});
